(ns frontend.view.nev.zap-vault.sub
  (:require [common.util :as cu]
            [frontend.state.current-session :as session]
            [frontend.view.nev.zap-vault.model :as model]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [reagent.ratom :as ratom]
            [ui.state.session.sub :as session-sub]
            [ui.view.card.entity-list.util :as entity-list-util]))

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::active-tab
 :<-
 [::state]
 (fn [state _]
   (get state model/active-tab-key)))

(rf/reg-sub
 ::vault-id
 :<-
 [::state]
 (fn [state _]
   (get state model/vault-id-key)))

(rf/reg-sub-raw
 ::vault
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [::vault-id])
         (session/get-entity)))))

(rf/reg-sub
 ::vault-with-updates
 :<-
 [::state]
 :<-
 [::vault]
 (fn [[state saved-vault] _]
   (potpuri/deep-merge (or saved-vault {})
                       (get state model/vault-changes-key {}))))

(rf/reg-sub
 ::vault-and-config-changes
 :<-
 [::state]
 :<-
 [::vault]
 (fn [[state vault] _]
   (->> {(:db/id vault)                   (get state model/vault-changes-key)
         (:zap-vault/configuration vault) (get state model/config-changes-key)}
        (cu/remove-nil-vals)
        (into {})
        (seq))))

(rf/reg-sub-raw
 ::documents
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [::vault])
         :common/attachments
         (keep session/get-entity)
         (remove :common/disabled?)
         (sort-by :common/ord)
         (vec)))))

(rf/reg-sub
 ::file-id-to-delete
 :<-
 [::state]
 (fn [state _]
   (get state model/delete-attachment-key)))

(rf/reg-sub
 ::file-id-to-edit
 :<-
 [::state]
 (fn [state _]
   (get state model/edit-attachment-key)))

(rf/reg-sub
 ::file-to-edit
 :<-
 [::documents]
 :<-
 [::file-id-to-edit]
 (fn [[documents file-id] _]
   (->> documents
        (cu/filter-by :db/id file-id)
        (first))))

(rf/reg-sub
 ::document-changes
 :<-
 [::state]
 (fn [state _]
   (get state model/document-changes-key)))

(rf/reg-sub
 ::file-to-delete
 :<-
 [::documents]
 :<-
 [::file-id-to-delete]
 (fn [[documents file-id] _]
   (->> documents
        (cu/filter-by :db/id file-id)
        (first))))

(rf/reg-sub-raw
 ::vault-config
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [::vault])
         :zap-vault/configuration
         (session/get-entity)))))

(rf/reg-sub-raw
 ::default-config
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [::session-sub/tenant])
         :tenant/default-vault-config
         (session/get-entity)))))

(rf/reg-sub
 ::config-changes
 :<-
 [::state]
 (fn [state _]
   (get state model/config-changes-key)))

(rf/reg-sub
 ::config-with-updates
 :<-
 [::default-config]
 :<-
 [::vault-config]
 :<-
 [::config-changes]
 (fn [[default-config vault-config config-changes] _]
   (let [merged-config (potpuri/deep-merge (or default-config {})
                                           (or vault-config {})
                                           (or config-changes {}))]
     merged-config)))

(rf/reg-sub
 ::vault-logo
 :<-
 [::config-with-updates]
 (fn [config _]
   (get config :vault-config/vault-logo)))

(rf/reg-sub
 ::activities
 :<-
 [::state]
 (fn [state _]
   (get state model/activities-key)))

(rf/reg-sub
 ::activity-table-columns
 (fn [_db _]
   [{:field :vault-usage/email}
    {:field :vault-usage/type}
    {:field :vault-usage/filename}
    {:field :common/created-on}]))

(rf/reg-sub
 ::activities-table-data
 :<-
 [::activity-table-columns]
 :<-
 [::activities]
 :<-
 [::session-sub/tenant]
 :<-
 [::session-sub/tenant-schema]
 (fn [[columns activities tenant tenant-schema] _]
   (let [column-fields (mapv :field columns)]
     (entity-list-util/entities->table-row-data
      {:entities       activities
       :column-fields  column-fields
       :entities-by-id {}
       :tenant         tenant
       :tenant-schema  tenant-schema}))))

(rf/reg-sub
 ::preview?
 :<-
 [::state]
 (fn [state _]
   (get state model/preview?-key)))

(rf/reg-sub
  ::preview-confirmed?
  :<-
  [::state]
  (fn [state _]
    (get state model/preview-confirmed?-key)))
